export default "__VITE_ASSET__BnMACvyC__"